"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Path = void 0;
class Path {
    constructor(value) {
        if (value == null || value == undefined) {
            throw new Error("Path value cannot be null");
        }
        this.Value = value.trim();
    }
    get Name() {
        return this.Segments.slice(-1)[0];
    }
    get NameWithoutExtension() {
        return this.Segments.slice(-1)[0].replace(/\.[^\.]+$/, "");
    }
    get Parent() {
        const lastSlashIndex = Math.max(this.Value.lastIndexOf("/"), this.Value.lastIndexOf("\\"));
        if (lastSlashIndex < 0) {
            throw new Error(`Cannot get parent of path '${this.Value}'.`);
        }
        return new Path(this.Value.substring(0, lastSlashIndex));
    }
    get Segments() {
        return Path.Split(this.Value);
    }
    get HasSubPath() {
        return this.Segments.length > 1;
    }
    get Ancestors() {
        if (this.Segments.length > 1) {
            return this.Parent.Ancestors.concat([this]);
        }
        else {
            return [this];
        }
    }
    ToString(separator) {
        return this.Value.replace(/[\\\/]/g, separator);
    }
    WithExtension(ext) {
        ext = ext.replace(/^\./, "");
        const newValue = this.Value.replace(/\.[^\.]+$/, `.${ext}`);
        return new Path(newValue);
    }
    WithName(name) {
        return this.Parent.Concat([name]);
    }
    WithBasename(basename) {
        const ext = (this.Name.match(/\.[^\.]+$/) || [])[0] || "";
        const name = basename + ext;
        return this.WithName(name);
    }
    WithParent(parent) {
        return parent.Concat([this.Name]);
    }
    Equals(another) {
        const normalize = (path) => path.ToString("/").toLowerCase();
        return normalize(this) === normalize(another);
    }
    Concat(segmentsOrSegment) {
        const segments = typeof segmentsOrSegment === "string" ? [segmentsOrSegment] : segmentsOrSegment;
        const dominantSeparator = Path.GetDominantSeparator(this.Value);
        return new Path([this.Value.replace(/[\\\/]$/, ""), ...segments].join(dominantSeparator));
    }
    toString() {
        return this.Value;
    }
    StartsWith(path) {
        return this.Segments.length >= path.Segments.length
            && this.Segments.slice(0, path.Segments.length)
                .every((thisSegment, index) => thisSegment.toLowerCase() === path.Segments[index].toLowerCase());
    }
    static Split(value) {
        return value.split(/[\\\/]+/).filter(segment => !!segment);
    }
    static *GetErrors(value) {
        for (const segment of this.Split(value)) {
            if (!Path.IsValidSegment(segment)) {
                yield `Segment '${segment}' contains invalid characters`;
            }
        }
    }
    static IsValidSegment(segment) {
        return !!segment && !segment.match(/["<>|*?:\/\\]/);
    }
    static GetDominantSeparator(value) {
        return ["/", "\\"]
            .map(separator => [separator, value.split(separator).length - 1])
            .sort(([_, countA], [__, countB]) => countB - countA)
            .map(([sep, _]) => sep)[0];
    }
}
exports.Path = Path;
//# sourceMappingURL=path.js.map